import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import { useCallback, useEffect, useState } from 'react'
import { batch, useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import { LoadingIndicator } from '../../components/Loading'
import { loadSavedUserInspirationIds } from '../../redux/actions/SaveInspirationAction'
import DcoinsHistory from './components/profile/DcoinsHistory'
import { Designs } from './components/profile/Designs'
import Sidebar from './components/profile/Sidebar'
import { loadMe, loadOthers, resetOtherUser } from './store/profileReducer'
const AvatarModal = dynamic(() => import('./components/profile/AvatarEdit/AvatarModal'), {
  ssr: false
})

const Container = styled.div`
  display: block;
  height: auto;
  position: relative;

  @media (min-width: 1000px) {
    height: calc(100vh - 65px);
    display: flex;
  }
`

const LoadingContainer = styled.div`
  width: 100vw;
  margin-top: 10vh;
`

const Profile = () => {
  const {
    query: { userId, uniqueDisplayName, avatar },
    push
  } = useRouter()

  const dispatch = useDispatch()
  const { me, others, loading } = useSelector(state => state.profile)

  const [isCoinsHistoryOpened, setCoinsHistoryOpened] = useState(false)
  const [isAvatarModalOpened, setAvatarModalOpened] = useState(false)

  const openCoinsHistory = useCallback(() => setCoinsHistoryOpened(true), [])
  const closeCoinsHistory = useCallback(() => setCoinsHistoryOpened(false), [])

  const isOthers = (typeof userId !== 'undefined' && me?.objectId !== userId) || (typeof uniqueDisplayName !== 'undefined' && me?.uniqueDisplayName !== uniqueDisplayName)

  useEffect(() => {
    if (avatar && avatar === 'true') {
      setAvatarModalOpened(true)
    }
  }, [push, avatar])

  useEffect(() => {
    if (isOthers) {
      dispatch(loadOthers({ userId, uniqueDisplayName }))

      return () => {
        dispatch(resetOtherUser())
      }
    }

    if (!userId || !isOthers) {
      batch(() => {
        dispatch(loadMe({ history: {} }))
        dispatch(loadSavedUserInspirationIds())
      })
    }
  }, [dispatch, userId, uniqueDisplayName, isOthers])

  if (loading) {
    return (
      <Container isOthers={isOthers}>
        <LoadingContainer>
          <LoadingIndicator loading />
        </LoadingContainer>
      </Container>
    )
  }

  return (
    <>
      <Container isOthers={isOthers}>
        <Sidebar isOthers={isOthers} openCoinsHistory={openCoinsHistory} setAvatarModalOpened={setAvatarModalOpened} />
        <Designs isOthers={isOthers} userid={others?.objectId || me?.objectId} openCoinsHistory={openCoinsHistory} />
        <DcoinsHistory isOpen={isCoinsHistoryOpened} handleClose={closeCoinsHistory} />
        {isAvatarModalOpened && <AvatarModal setOpened={setAvatarModalOpened} />}
      </Container>
    </>
  )
}

export default Profile
